export const colorMoods = [
  { label: "Auto", value: "auto" },
  { label: "Calm", value: "calm" },
  { label: "Energized", value: "energetic" },
  { label: "Warm", value: "warm" },
  { label: "Playful", value: "playful" },
  { label: "Dramatic", value: "dramatic" },
  { label: "Sophisticated", value: "sophisticated" },
];
export const colorSchemes = [
  { label: "Auto", value: "auto" },
  { label: "Monochrome", value: "monochrome" },
  // { label: "Monochrome Light", value: "monochrome-light" },
  // { label: "Monochrome Dark", value: "monochrome-dark" },
  // { label: "Triadic", value: "triad" },
  // { label: "Quadratic", value: "quad" },
  { label: "Analogous", value: "analogic" },
  { label: "Complementary", value: "complement" },
  // { label: "Analogous Complementary", value: "analogic-complement" },
];

export const PALETTE_TYPES = {
  WHEEL: "wheel",
  SEGMENT: "segment",
};

//  - PALETTE_DEFER_AUTOSAVE_WHILE_GENERATING: the 30s autosave timer skips a
//    tick while any segment-palette generate/save is still in flight, so a save
//    can't persist a stale snapshot whose palette_id/palette_data hasn't landed
//    in Redux yet (LW-02 stale-state save race). The index marker is NOT
//    advanced on a skipped tick, so the change is still saved on the next tick
//    (or on a manual save). Reversible: false restores the always-save-on-tick
//    behaviour.
export const PALETTE_DEFER_AUTOSAVE_WHILE_GENERATING =
  process.env.REACT_APP_PALETTE_DEFER_AUTOSAVE_WHILE_GENERATING !== "false";
